import { HttpStatusCode } from '@thesavingsgroup/enums/HttpStatusCode';

/**
 * Builds the redirect a vehicle route loader returns to send the user elsewhere.
 *
 * The parameters of the originating request are carried onto the redirect so guards
 * reading them afterwards (ex: `RouteChangeGuard`'s analytics) still see them.
 */
export const toDashboardRedirect = (path: string, url: string): Response => {
  const redirectUrl = new URL(path, window.location.origin);

  redirectUrl.search = new URL(url).search;

  return Response.redirect(redirectUrl.toString(), HttpStatusCode.FOUND);
};
